import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLocaleFromPathname } from '../config/localeRoutes';
import './Hero.css';

function Hero() {
  const { t } = useTranslation();
  const location = useLocation();
  const locale = getLocaleFromPathname(location.pathname);
  const webrtcPath = locale === 'en' ? '/en/webrtc-video-infrastructure/' : '/webrtc/';
  const hostingPath = locale === 'en' ? '/en/france-hosted-video-platform/' : '/hebergement-france/';
  
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 80;
      const elementPosition = element.offsetTop - headerHeight;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="accueil" className="hero">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            {t('hero.title')}
          </h1>
          <p className="hero-tagline">
            {t('hero.tagline')}
          </p>
          <aside className="hero-what-is" aria-labelledby="hero-what-is-title">
            <h2 id="hero-what-is-title" className="hero-what-is-title">
              {t('hero.whatIsTitle')}
            </h2>
            <p className="hero-what-is-text">{t('hero.whatIsDescription1')}</p>
            <p className="hero-what-is-text">{t('hero.whatIsDescription2')}</p>
          </aside>
          <div className="hero-buttons">
            <button
              onClick={() => scrollToSection('contact')}
              className="btn btn-primary"
            >
              {t('hero.ctaPrimary')}
            </button>
            <Link
              to={locale === 'en' ? '/en/quote/' : '/devis/'}
              className="btn btn-secondary"
            >
              {t('hero.ctaQuote')}
            </Link>
            <button
              onClick={() => scrollToSection('solutions')}
              className="btn btn-secondary"
            >
              {t('hero.ctaSolutions')}
            </button>
          </div>
          <p className="hero-hub-links">
            <Link to={webrtcPath}>{t('hero.linkWebrtc')}</Link>
            <span aria-hidden="true"> · </span>
            <Link to={hostingPath}>{t('hero.linkHosting')}</Link>
          </p>
        </div>
      </div>
      <div className="hero-background"></div>
    </section>
  );
}

export default Hero;
